import { Eye, EyeOff, Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const PostMeta = ({ post }) => (
  <div className="min-w-0">
    <div className="flex items-center gap-2 text-xs text-slate-500">
      <span className="font-semibold uppercase tracking-wider text-blue-700">{post.category}</span>
      <span>· {post.locale}</span>
      <span>· {post.published ? "Published" : "Draft"}</span>
    </div>
    <h3 className="mt-1 truncate text-base font-bold text-slate-900">{post.title}</h3>
    <p className="truncate text-xs text-slate-500">/insights/{post.slug}</p>
  </div>
);

const PostActions = ({ post, onTogglePublish, onEdit, onDelete }) => (
  <div className="flex flex-wrap items-center gap-2">
    <Button
      variant="outline"
      className="h-9 rounded-lg border-slate-300 bg-white"
      onClick={() => onTogglePublish(post)}
      data-testid={`admin-post-toggle-${post.slug}`}
    >
      {post.published ? (
        <><EyeOff className="mr-1.5 h-4 w-4" /> Unpublish</>
      ) : (
        <><Eye className="mr-1.5 h-4 w-4" /> Publish</>
      )}
    </Button>
    <Button
      variant="outline"
      className="h-9 rounded-lg border-slate-300 bg-white"
      onClick={() => onEdit(post)}
      data-testid={`admin-post-edit-${post.slug}`}
    >
      <Pencil className="mr-1.5 h-4 w-4" /> Edit
    </Button>
    <Button
      variant="outline"
      className="h-9 rounded-lg border-red-200 bg-white text-red-700 hover:bg-red-50"
      onClick={() => onDelete(post.id)}
      data-testid={`admin-post-delete-${post.slug}`}
    >
      <Trash2 className="mr-1.5 h-4 w-4" /> Delete
    </Button>
  </div>
);

export const AdminPostsTable = ({ posts, onTogglePublish, onEdit, onDelete }) => (
  <>
    <h2 className="mt-12 text-lg font-extrabold text-slate-900">All posts ({posts.length})</h2>
    <div className="mt-4 overflow-hidden rounded-2xl border border-slate-200 bg-white">
      {posts.length === 0 ? (
        <div className="p-8 text-center text-sm text-slate-500">
          No posts yet. Create your first above.
        </div>
      ) : (
        <ul className="divide-y divide-slate-200">
          {posts.map((post) => (
            <li
              key={post.id}
              className="flex flex-col gap-3 p-5 sm:flex-row sm:items-center sm:justify-between"
              data-testid={`admin-post-row-${post.slug}`}
            >
              <PostMeta post={post} />
              <PostActions
                post={post}
                onTogglePublish={onTogglePublish}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  </>
);
